import CaseStudyFiveContainer from "./containers/CaseStudyFiveContainer";
export default CaseStudyFiveContainer;
